import { memo } from 'react';
import { Grid, Stack, Typography } from 'components/ui';
import { useNavigate } from 'react-router-dom';
import { InspectionSubjectLink } from 'utils/link';
import { IndexListItemButton } from 'components/styles_components/list';
import { FormattedMessage } from 'react-intl';
import InspectionSubject from 'utils/inspection_subject';
import useMobile from 'hooks/use_mobile';
import CountCircle from 'components/count_circle';

const ListItem = ({ inspectionSubject }) => {
  const navigate = useNavigate();
  const inspectionSubjectUtil = InspectionSubject(inspectionSubject);
  const isMobile = useMobile();
  const nameGridWidth = isMobile ? 12 : 4;

  return (
    <IndexListItemButton
      className={inspectionSubjectUtil.htmlClass}
      onClick={() => {
        navigate(InspectionSubjectLink(inspectionSubject.id));
      }}
    >
      <Grid container justifyContent="center" alignItems="center" spacing={2}>
        <Grid size={{ xs: nameGridWidth }}>
          <Stack>
            <Typography variant="button">{inspectionSubject.name}</Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              <FormattedMessage id="place" />: {inspectionSubject.place.name}
            </Typography>
          </Stack>
        </Grid>
        {!isMobile && (
          <>
            <Grid textAlign="center" size={{ xs: 2 }}>
              {inspectionSubject.brand || '-'}
            </Grid>
            <Grid textAlign="center" size={{ xs: 2 }}>
              {inspectionSubject.model || '-'}
            </Grid>
            <Grid textAlign="center" size={{ xs: 2 }}>
              {inspectionSubject.serialNumber || '-'}
            </Grid>
            <Grid textAlign="center" size={{ xs: 1 }}>
              <CountCircle count={inspectionSubject.incomingInspectionsTotal} color="warning" />
            </Grid>
            <Grid textAlign="center" size={{ xs: 1 }}>
              <CountCircle count={inspectionSubject.overdueInspectionsTotal} color="error" />
            </Grid>
          </>
        )}
      </Grid>
    </IndexListItemButton>
  );
};

export default memo(ListItem);
